const CANCEL_TYPES = {
  trial: 'SGTF Trial',
  seasonal: 'Seasonal Subscription',
  annual: 'Annual Subscription',
};

export default CANCEL_TYPES;
